





































import Vue from 'vue'
import request from '@/utils/requestExt'

export default Vue.extend({
    data() {
        return {
            loading: true,
            navTitle: '我的评价',
            name: '',
            courseId: '',
            wareData: [],
        }
    },
    created() {
        // @ts-ignore
        const getCourseId: string = this.$route.query.courseId
        if (typeof getCourseId !== 'undefined') {
            this.courseId = getCourseId
        }
        this.getData()
    },
    methods: {
        getData() {
            const params = {
                name: this.name,
                courseId: this.courseId,
            }
            request.get('/api/course_ware/query', params)
            .then((data) => {
                console.log(data)
                this.wareData = data
            })

            this.loading = false
        },
        chackDatails(item: any) {
            this.$router.push({ path: `/kejian_details/${item}` })
        },
        comment(item: any) {
               this.$router.push({ path: `/kejian_evaluate/${item}` })
        },
        download(item: any) {
            window.open(item, '_blank');
        },
    },
})
